(() => {
  'use strict';
  if (window.__ossJerseyAccordionFiltersInstalled) return;
  window.__ossJerseyAccordionFiltersInstalled = true;

  const MOBILE_QUERY = '(max-width: 767px)';
  const PAGE_SIZE = 48;
  const CATALOG_MUTATION_SELECTOR = '.oss-jersey-custom-template, .oss-jersey-product-card, [data-oss-jersey-product-data]';
  const state = { league: null, club: null, type: null };
  const dataByHandle = new Map();
  let loadPromise = null;
  let lastMobile = window.matchMedia(MOBILE_QUERY).matches;

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;
  const getRoot = () => document.querySelector('.oss-jersey-custom-template');
  const clean = (value) => String(value == null ? '' : value).trim();
  const key = (value) => clean(value).toLocaleLowerCase('en');
  const isActive = () => !!(state.league || state.club || state.type);
  const formatProducts = (count) => `${count} product${count === 1 ? '' : 's'}`;

  const cardHandle = (card) => {
    const link = card.querySelector('.product-block__title-link[href*="/products/"], a[href*="/products/"]');
    const match = String(link?.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const collectData = (scope) => {
    if (!scope?.querySelectorAll) return;
    scope.querySelectorAll('[data-oss-jersey-product-data]').forEach((node) => {
      try {
        const items = JSON.parse(node.textContent);
        if (!Array.isArray(items)) return;
        items.forEach((item) => {
          const handle = clean(item?.handle);
          if (!handle) return;
          dataByHandle.set(handle, {
            handle,
            club: clean(item?.club),
            league: clean(item?.league),
            home: item?.home === true,
            away: item?.away === true,
            third: item?.third === true,
            authentic: item?.authentic === true,
            longSleeve: item?.longSleeve === true
          });
        });
      } catch (error) {
        console.warn('[OneSportyStore] Jersey filter metadata could not be parsed.', error);
      }
    });
  };

  const matches = (meta) => {
    if (!meta) return false;
    if (state.league && meta.league !== state.league) return false;
    if (state.club && key(meta.club) !== state.club) return false;
    if (state.type && meta[state.type] !== true) return false;
    return true;
  };

  const updateButtons = (root) => {
    root.querySelectorAll('[data-oss-jersey-league]').forEach((button) => {
      const active = button.dataset.ossJerseyLeague === state.league;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-oss-jersey-club]').forEach((button) => {
      const active = button.dataset.ossJerseyClub === state.club;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-oss-jersey-type]').forEach((button) => {
      const active = button.dataset.ossJerseyType === state.type;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const getAvailableClubs = () => {
    const clubsByKey = new Map();

    dataByHandle.forEach((meta) => {
      if (!meta.club) return;
      if (state.league && meta.league !== state.league) return;

      const clubKey = key(meta.club);
      if (!clubsByKey.has(clubKey)) clubsByKey.set(clubKey, meta.club);
    });

    return Array.from(clubsByKey.entries())
      .map(([clubKey, name]) => ({ clubKey, name }))
      .sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
  };

  const renderClubOptions = (root, { resetScroll = false } = {}) => {
    const list = root.querySelector('[data-oss-jersey-club-list]');
    if (!list) return;

    const clubs = getAvailableClubs();
    const availableKeys = new Set(clubs.map((club) => club.clubKey));

    if (state.club && !availableKeys.has(state.club)) {
      state.club = null;
    }

    const fragment = document.createDocumentFragment();

    if (!clubs.length) {
      const empty = document.createElement('span');
      empty.className = 'oss-jersey-club-loading oss-jersey-club-empty';
      empty.textContent = state.league
        ? 'No clubs available in this league yet.'
        : 'No clubs available.';
      fragment.appendChild(empty);
    } else {
      clubs.forEach(({ clubKey, name }) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'oss-boots-player-chip oss-boots-player-chip--limited oss-jersey-filter-chip';
        button.dataset.ossJerseyClub = clubKey;
        button.setAttribute('aria-pressed', state.club === clubKey ? 'true' : 'false');
        button.textContent = name;
        if (state.club === clubKey) button.classList.add('is-active');
        fragment.appendChild(button);
      });
    }

    list.replaceChildren(fragment);
    if (resetScroll) list.scrollLeft = 0;
  };

  const applyFilters = (root = getRoot()) => {
    if (!root) return;
    collectData(root);

    const active = isActive();
    let visible = 0;

    root.querySelectorAll('.oss-jersey-product-card').forEach((card) => {
      const handle = cardHandle(card);
      const meta = dataByHandle.get(handle);
      const isExtra = card.dataset.ossJerseyExtra === 'true';
      const show = active ? matches(meta) : !isExtra;

      card.classList.toggle('oss-jersey-filter-hidden', !show);
      card.hidden = !show;
      if (show) visible += 1;
    });

    updateButtons(root);

    const total = Number(root.dataset.ossTotalCount || 0);
    root.querySelectorAll('[data-oss-jersey-results-summary]').forEach((node) => {
      node.textContent = formatProducts(active ? visible : total);
    });

    root.querySelectorAll('[data-oss-jersey-quick-count]').forEach((node) => {
      node.textContent = active && !isMobile() ? `${visible} matching products` : '';
    });

    const empty = root.querySelector('[data-oss-jersey-no-results]');
    if (empty) empty.hidden = !(active && visible === 0);

    root.querySelectorAll('.pagination, .pagination-row').forEach((pagination) => {
      pagination.hidden = active;
    });
  };

  const appendFetchedPage = (root, fetchedRoot) => {
    if (!root || !fetchedRoot) return;
    collectData(fetchedRoot);

    const grid = root.querySelector('[data-oss-jersey-grid]');
    if (!grid) return;

    const existing = new Set(
      Array.from(root.querySelectorAll('.oss-jersey-product-card')).map(cardHandle).filter(Boolean)
    );

    fetchedRoot.querySelectorAll('.oss-jersey-product-card').forEach((card) => {
      const handle = cardHandle(card);
      if (handle && existing.has(handle)) return;
      if (handle) existing.add(handle);

      card.dataset.ossJerseyExtra = 'true';
      card.classList.add('oss-jersey-filter-hidden');
      card.hidden = true;
      grid.appendChild(card);
    });
  };

  const loadAllPages = async (root = getRoot()) => {
    if (!root) return;
    collectData(root);

    if (root.dataset.ossAllPagesLoaded === 'true') return;

    const total = Number(root.dataset.ossTotalCount || 0);
    const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));

    if (totalPages <= 1) {
      root.dataset.ossAllPagesLoaded = 'true';
      return;
    }

    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
      const currentUrl = new URL(window.location.href);
      const currentPage = Number(currentUrl.searchParams.get('page') || '1');
      const sectionId = root.dataset.sectionId;
      const pages = [];

      for (let page = 1; page <= totalPages; page += 1) {
        if (page !== currentPage) pages.push(page);
      }

      const fetchedRoots = await Promise.all(pages.map(async (page) => {
        const url = new URL(currentUrl.toString());
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString(), {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) return null;
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.querySelector('.oss-jersey-custom-template');
      }));

      const successfulRoots = fetchedRoots.filter(Boolean);
      successfulRoots.forEach((fetchedRoot) => appendFetchedPage(root, fetchedRoot));

      if (successfulRoots.length === pages.length) {
        root.dataset.ossAllPagesLoaded = 'true';
      }
    })().catch((error) => {
      console.warn('[OneSportyStore] Could not load all jersey filter pages.', error);
    }).finally(() => {
      loadPromise = null;
    });

    return loadPromise;
  };

  const accordionSlug = (label, index) => {
    const slug = clean(label || `group-${index + 1}`)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || `group-${index + 1}`;
  };

  const syncAccordionViewport = (root = getRoot()) => {
    if (!root) return;

    root.querySelectorAll('[data-oss-mobile-accordion]').forEach((group) => {
      const trigger = group.querySelector(':scope > [data-oss-accordion-trigger]');
      if (!trigger) return;

      if (!isMobile()) {
        group.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        return;
      }

      const open = group.dataset.ossAccordionOpen === 'true';
      group.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  const ensureAccordions = (root = getRoot()) => {
    if (!root || !isMobile()) return;

    const quickFilters = root.querySelector('.oss-boots-quick-filters');
    if (!quickFilters) return;

    Array.from(quickFilters.querySelectorAll(':scope > .oss-boots-filter-group')).forEach((group, index) => {
      let heading = group.querySelector(':scope > .oss-boots-filter-group__heading');
      const row = group.querySelector(':scope > .oss-boots-filter-row');
      if (!heading || !row) return;

      const labelText = heading.dataset.ossAccordionLabel || clean(heading.textContent);
      let trigger = heading;

      if (!heading.matches('[data-oss-accordion-trigger]')) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = `${heading.className} oss-boots-accordion-trigger`;
        trigger.dataset.ossAccordionTrigger = 'true';
        trigger.dataset.ossAccordionLabel = labelText;

        const label = document.createElement('span');
        label.className = 'oss-boots-accordion-label';
        label.textContent = labelText;

        const chevron = document.createElement('span');
        chevron.className = 'oss-boots-accordion-chevron';
        chevron.setAttribute('aria-hidden', 'true');

        trigger.append(label, chevron);
        heading.replaceWith(trigger);
      }

      const panelId = row.id || `oss-jersey-accordion-${accordionSlug(labelText, index)}`;
      row.id = panelId;
      row.dataset.ossAccordionPanel = 'true';
      trigger.setAttribute('aria-controls', panelId);
      group.dataset.ossMobileAccordion = 'true';

      if (group.dataset.ossAccordionInitialized !== 'true') {
        group.dataset.ossAccordionInitialized = 'true';
        group.dataset.ossAccordionOpen = 'false';
      }
    });

    syncAccordionViewport(root);
  };

  const refreshState = (root, { refreshClubs = false, resetClubScroll = false } = {}) => {
    if (!root) return;

    ensureAccordions(root);
    updateButtons(root);

    if (refreshClubs) {
      renderClubOptions(root, { resetScroll: resetClubScroll });
    }

    applyFilters(root);

    if (root.dataset.ossAllPagesLoaded !== 'true') {
      void loadAllPages(root).then(() => {
        if (!root.isConnected) return;
        renderClubOptions(root);
        applyFilters(root);
      });
    }
  };

  const openCombinedPanel = (root) => {
    const trigger = root.querySelector('.cc-filters-control .js-show-filters') ||
      root.querySelector('.cc-filters-control .js-show-sort');
    if (trigger) trigger.click();
  };

  document.addEventListener('click', (event) => {
    const root = getRoot();
    if (!root || !root.contains(event.target)) return;

    const accordion = event.target.closest('[data-oss-accordion-trigger]');
    if (accordion && isMobile()) {
      event.preventDefault();
      const group = accordion.closest('[data-oss-mobile-accordion]');
      if (group) {
        group.dataset.ossAccordionOpen = group.dataset.ossAccordionOpen === 'true' ? 'false' : 'true';
        syncAccordionViewport(root);
      }
      return;
    }

    const filterSort = event.target.closest('[data-oss-filter-sort-trigger]');
    if (filterSort) {
      event.preventDefault();
      openCombinedPanel(root);
      return;
    }

    const league = event.target.closest('[data-oss-jersey-league]');
    if (league) {
      event.preventDefault();
      const value = league.dataset.ossJerseyLeague || null;
      state.league = state.league === value ? null : value;
      state.club = null;
      refreshState(root, { refreshClubs: true, resetClubScroll: true });
      return;
    }

    const club = event.target.closest('[data-oss-jersey-club]');
    if (club) {
      event.preventDefault();
      const value = club.dataset.ossJerseyClub || null;
      state.club = state.club === value ? null : value;
      refreshState(root);
      return;
    }

    const type = event.target.closest('[data-oss-jersey-type]');
    if (type) {
      event.preventDefault();
      const value = type.dataset.ossJerseyType || null;
      state.type = state.type === value ? null : value;
      refreshState(root);
    }
  });

  const initRoot = (root = getRoot()) => {
    if (!root) return;

    collectData(root);
    ensureAccordions(root);

    if (root.dataset.ossJerseyInitialized === 'true') {
      applyFilters(root);
      return;
    }

    root.dataset.ossJerseyInitialized = 'true';
    renderClubOptions(root);
    applyFilters(root);

    void loadAllPages(root).then(() => {
      if (!root.isConnected) return;
      renderClubOptions(root);
      applyFilters(root);
    });
  };

  const handleViewportChange = () => {
    const mobile = isMobile();
    if (mobile === lastMobile) return;

    lastMobile = mobile;
    const root = getRoot();
    if (!root) return;

    if (mobile) {
      ensureAccordions(root);
      root.querySelectorAll('[data-oss-mobile-accordion]').forEach((group) => {
        group.dataset.ossAccordionOpen = 'false';
      });
    }

    syncAccordionViewport(root);
  };

  const mutationTouchesCatalog = (mutation) => {
    const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
    return nodes.some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches(CATALOG_MUTATION_SELECTOR) || !!node.querySelector(CATALOG_MUTATION_SELECTOR);
    });
  };

  const init = () => initRoot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  window.addEventListener('resize', handleViewportChange, { passive: true });

  let observerTimer = null;
  new MutationObserver((mutations) => {
    if (!mutations.some(mutationTouchesCatalog)) return;
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(() => initRoot(), 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
